import React from "react";
export default function Header(){

    return(

        <div className="header">
           <h1>birdjpg.io</h1><h2>get bird.</h2>
        </div>
    )
}